import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';

export interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  color?: string;
  className?: string;
}

export const Loader = forwardRef<HTMLDivElement, LoaderProps>(
  (
    { size = 40, color = '#111', className, ...forwardingProps },
    forwardingRef
  ) => {
    return (
      <Container {...forwardingProps} ref={forwardingRef} className={className}>
        <Spinner _size={size} _color={color} />
      </Container>
    );
  }
);

const spinning = keyframes`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<{
  _size: number;
  _color: string;
}>`
  width: ${({ _size }) => _size}px;
  height: ${({ _size }) => _size}px;
  border-color: ${({ _color }) => _color};
  border-top-color: transparent;
  display: block;
  border-style: solid;
  border-radius: 50%;
  border-width: 2px;
  box-sizing: border-box;
  animation: ${spinning} 1s infinite linear;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
